var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

function ScheduleList(el) {
  this.el = el;
 	this.$el = $(el);

  this.$el.find('.schedule-item').on('click', '.schedule-item__header', function() {
    $(this).closest('.schedule-item').toggleClass('schedule-item__active');
  });

}

module.exports = ScheduleList;
